import { useEffect, useState } from "react";
import { AllocationPool } from "./types";

const errorText =
  "Please fill all the fields in the DHCP Allocation pools, or disable DHCP";
const initialPool: AllocationPool = { start: "", end: "" };

const validatePools = (data: AllocationPool[]) =>
  data.every((pool) => pool.start && pool.end);

const useDHCPPoolsValidation = (isIPv4: boolean, dhcpStatus: boolean) => {
  const [allocationPools, setDHCPPools] = useState<AllocationPool[]>([
    initialPool,
  ]);
  const [dhcpPoolsError, setDHCPPoolsError] = useState("");

  useEffect(() => {
    const isValid = validatePools(allocationPools);
    if (isIPv4 && dhcpStatus) {
      setDHCPPoolsError(isValid ? "" : errorText);
    } else {
      setDHCPPoolsError("");
    }
  }, [allocationPools, dhcpPoolsError, dhcpStatus, isIPv4]);

  return {
    allocationPools,
    dhcpPoolsError,
    onAllocationPoolsChange: setDHCPPools,
  };
};
export default useDHCPPoolsValidation;
